import React from 'react'
import Slider from 'react-slick'
import Configurator from '../../configurator'
import {
    fetchSports,
    setFinishedOnBoardingAction,
    setOnBoardingStepAction,
} from '../../admin/actions/on-boarding'
import WelcomeOnBoarding from './welcome'
import SportOnboarding from './sport'
import RelationshipOnboarding from './relationship'
import PlaceOnBoarding from './place'
import BirthdayOnBoarding from './birthday'
import AchievementOnBoarding from './achievement'
import Modal from '../modal'
import {
    ON_BOARDING_STEPS_IN_PROGRESS,
    ON_BOARDING_STEP_WELCOME,
    ON_BOARDING_STEP_SPORT,
    ON_BOARDING_STEP_CITY,
    ON_BOARDING_STEP_BIRTHDAY,
    ON_BOARDING_STEP_ACHIEVEMENT,
    ON_BOARDING_STEPS,
} from './hoc'
import SnIcon from '../../front/components/shared/sn-icon'
import StepProgress from '../../front/components/shared/sn-step-progress'
import { withRouterConnectWrapper } from '../../validator'
import OverlayLoader from '../shared/overlay-loader'

import {
    setUserOnBoardingToStore,
} from './helper'
import { isWebView } from '../../admin/actions'
import {
    EVENT_OTHER,
    sendWebViewEvent,
} from '../../events-webview'

const sliderImagesPathPrefix = '/images/on-boarding/'
const sliderImages = {
    [ON_BOARDING_STEP_WELCOME]: [
        `${sliderImagesPathPrefix}welcome-1.png`,
        `${sliderImagesPathPrefix}welcome-2.png`,
        `${sliderImagesPathPrefix}welcome-3.png`,
    ],
    [ON_BOARDING_STEP_SPORT]: [
        `${sliderImagesPathPrefix}sport-1.png`,
        `${sliderImagesPathPrefix}sport-2.png`,
        `${sliderImagesPathPrefix}sport-3.png`,
    ],
    [ON_BOARDING_STEP_CITY]: [
        `${sliderImagesPathPrefix}place-1.png`,
        `${sliderImagesPathPrefix}place-2.png`,
        `${sliderImagesPathPrefix}place-3.png`,
    ],
    [ON_BOARDING_STEP_BIRTHDAY]: [
        `${sliderImagesPathPrefix}birth-1.png`,
    ],
    [ON_BOARDING_STEP_ACHIEVEMENT]: [
        `${sliderImagesPathPrefix}success-1.png`,
        `${sliderImagesPathPrefix}success-2.png`,
        `${sliderImagesPathPrefix}success-3.png`,
    ],
}

const sliderConfig = {
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    centerPadding: '0',
    dots: false,
    fade: true,
    infinite: true,
    pauseOnHover: false,
    speed: 1500,
    slidesToScroll: 1,
    slidesToShow: 1,
    swipe: false,
}

class OnBoarding extends Configurator {

    state = {
        loaded: false,
    }

    componentDidMount() {
        const {
            location,
            onlySport,
        } = this.props

        fetchSports()

        if (onlySport) {
            setOnBoardingStepAction(ON_BOARDING_STEP_SPORT)
        }

        if (location.hash) {
            const parsedStep = parseInt(location.hash.split('-').slice(-1)[0], 10)
            const step = ON_BOARDING_STEPS.includes(parsedStep) ? parsedStep : 0

            setOnBoardingStepAction(step)
        }
    }

    /**
     * After load all props, parse user on-boarding into store
     */
    componentDidUpdate = () => {
        const {
            authedUser: {
                user,
            },
            fetchedSports,
            onlySport,
        } = this.props

        const { loaded } = this.state

        if (!loaded && user && fetchedSports && !onlySport) {
            setUserOnBoardingToStore(user, fetchedSports)
            this.setState({ loaded: true })
        }
    }

    /**
     * Go to prev step
     */
    gotoPrevStep = () => {
        const { currentStep } = this.props

        setOnBoardingStepAction(currentStep - 1)
    }


    /**
     * After success close on-boarding
     */
    closeOnBoarding = () => {
        return this.axios.post(`${this.config.REACT_APP_API_URL}api/users/me/finish-onboarding`)
            .then(() => {
                setFinishedOnBoardingAction(true)
                sendWebViewEvent(EVENT_OTHER, { close: true })
            })
    }

    /**
     * Render header (back button and step progress)
     * @return {*}
     */
    renderHeader = () => {
        const {
            currentStep,
            onlySport,
            onClose,
        } = this.props

        if (currentStep === ON_BOARDING_STEP_WELCOME) {
            return null
        }

        return (
            <div className="d-flex align-items-center w-100">
                <SnIcon
                    className="sn-arrow text-color-gray-dark-3 cursor-pointer"
                    onClick={(onlySport && currentStep === ON_BOARDING_STEP_SPORT) ? onClose : this.gotoPrevStep}
                />
                {!onlySport &&
                    <StepProgress
                        currentStep={currentStep}
                        countSteps={ON_BOARDING_STEPS_IN_PROGRESS}
                    />
                }
            </div>
        )
    }

    /**
     * Render slider image
     * @param {string} imageSrc
     * @param {number|string} key
     * @return {*}
     */
    renderImage = (imageSrc, key) => (
        <div key={key}>
            <img className="w-100 mx-auto max-width-400" src={imageSrc} alt="" />
        </div>
    )

    /**
     * Render slider with images, if exist some image for the current step
     * @return {null|*}
     */
    renderSliderWithImages = () => {
        const { currentStep } = this.props
        const images = sliderImages[currentStep] || null

        if (!images || images.length === 0) {
            return null
        }

        return (
            <Slider {...sliderConfig}>
                {images.map((item, index) => this.renderImage(item, index))}
            </Slider>
        )
    }

    /**
     * Close on-boarding after adding another sport
     */
    closeAfterRelationship = () => {
        this.closeOnBoarding()
            .then(() => {
                this?.props?.onClose?.()

                process.nextTick(() => {
                    window.location.reload()
                })
            })
    }

    /**
     * Render slider with images and content component for the current step
     * @return {*}
     */
    renderContent = () => {
        const {
            fetchSportsIsPending,
            editSport,
            sportId,
            authedUser: {
                user,
            },
        } = this.props

        return (
            <div className="p-4 position-relative">
                {this.renderHeader()}
                {this.renderSliderWithImages()}

                <WelcomeOnBoarding />
                <SportOnboarding
                    user={user}
                    sportId={sportId}
                    editSport={editSport}
                />
                <RelationshipOnboarding
                    onFinish={this.closeAfterRelationship}
                    user={user}
                    {...this.props}
                />
                <PlaceOnBoarding  user={user} />
                <BirthdayOnBoarding user={user} />
                <AchievementOnBoarding
                    onFinish={this.closeAfterRelationship}
                    user={user}
                />

                {fetchSportsIsPending && <OverlayLoader className="position-absolute" /> }
            </div>
        )
    }

    render = () => {
        const {
            authedUser: {
                user,
            },
        } = this.props

        if (isWebView()) {
            return this.renderContent()
        }

        if (this.isSfnProfile(user)) {
            return null
        }

        return (
            <Modal
                modalFadeClass="background-modal-overlay-darkest"
                content={this.renderContent}
                keyboard={false}
                backdrop="static"
                withoutHeader
            />
        )
    }
}

export default withRouterConnectWrapper(state => ({
    authedUser: state.auth,
    fetchedSports: state.onBoarding.sports,
    userData: state.onBoarding.userData,
    currentStep: state.onBoarding.currentStep,
    fetchSportsIsPending: state.onBoarding.fetchSportsIsPending,
}))(OnBoarding)
